import { createFileRoute } from '@tanstack/react-router';
import OnboardingLocation from '@/features/account/onboarding/location';

export const Route = createFileRoute('/onboarding/localidade')({
  component: OnboardingLocation,
});
